import React, { PureComponent } from "react"
import { SharedContext } from "@albelli/photoselector"
import { UploadProgress, UploadProgressStore } from "@albelli/image-list-view-upload-progress"
import "./mydevice.css"
import Immediate from "./Immediate"

type MyDeviceProps = {
  uploadProgress: UploadProgress
  uploader: any
}

type MyDeviceState = {
  uploadStore: UploadProgressStore
}

export class MyDevice extends PureComponent<MyDeviceProps, MyDeviceState> {
  static contextType = SharedContext

  constructor(props: any) {
    super(props)
    const { uploader } = props
    if (uploader) {
      const uploadProgress = this.props.uploadProgress
      const uploadStore = uploadProgress.getStore()
      this.state = { uploadStore }
    }
  }

  componentDidMount() {
    const { uploader } = this.props
    uploader && uploader.doneUploadingEvent(this.handleDoneUploading)
  }

  componentWillUnmount() {
    const { uploader } = this.props
    uploader && uploader.unsubscribeDoneUploadingEvent(this.handleDoneUploading)
  }

  handleDoneUploading = () => {
    this.forceUpdate()
  }

  render() {
    const { selection } = this.context
    //Depending on configuration, we should either upload immediately or wait untill the user clicks "done"
    //The implementations of these two are quite different, thus seperate react classes.
    if (!this.props.uploader) {
      return (
        <div className="photoselector-mydevice-wrapper" style={{ color: "red" }}>
          If My Device is enabled, you need to give an instance of the uploader to the constructor of the PhotoSelector
        </div>
      )
    } else {
      return <Immediate {...this.state} {...this.props} selection={selection} />
    }
  }
}
